module.exports = __webpack_public_path__ + "img/e6ab073d97335a3c5bf8e5b10dded6d2.svg";